import * as yup from 'yup'

export default yup.object().shape({
  buyers: yup.array().min(1, 'É necessário ao menos um Promissário.')
})
